import React, { useEffect } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { Calendar, User, ArrowLeft, MessageCircle } from 'lucide-react';

const ArticleDetail = () => {
  const { slug } = useParams();
  const navigate = useNavigate();

  const articles = {
    'zengin-olmak': {
      title: 'Zengin olmak mı istiyorsunuz?',
      date: '12 Ekim 2018',
      author: 'Banu Gökcül',
      image: 'https://akarma.com.tr/upload/akarma/parayi-bollukla-hayatina-cek.jpg',
      category: 'Bolluk Bilinci',
      comments: 2,
      content: `
        <p class="lead">Zengin olmak mı istiyorsunuz? Tamam! Öyleyse, zihinsel sürecinizin hayali değerini belirlemek için, basit bir zihinsel monopoly oyunu oynayalım.</p>
        
        <p>Diyelim ki sahip olduğunuz her şeyi, "zihinsel monopoly"nizde bir mülk olarak düşünelim. Eviniz, arabanız, işiniz, ilişkileriniz, sağlığınız - bunların hepsi sizin monopoly oyununuzdaki mülkleriniz.</p>
        
        <h2>Para ve Zihinsel Programlamalarımız</h2>
        <p>Para konusundaki inançlarımız, çocukluk yıllarımızda şekillenmeye başlar. Ailemizden duyduğumuz "Para ağaçta yetişmez", "Zenginler mutlu olamaz", "Para her şey değildir" gibi cümleler bilinçaltımıza yerleşir ve hayatımız boyunca bizi etkiler.</p>
        
        <h3>NLP ile Para İlişkinizi Dönüştürün</h3>
        <p>Nöro-Linguistik Programlama (NLP) teknikleri kullanarak, para ile ilgili sınırlayıcı inançlarınızı tespit edebilir ve değiştirebilirsiniz. İşte adım adım yapabileceğiniz egzersizler:</p>
        
        <ol>
          <li><strong>Bilinçaltı İnançlarınızı Keşfedin:</strong> "Para hakkında ilk aklıma gelen ne?" sorusuna verdiğiniz yanıt, bilinçaltınızdaki programlamayı gösterir.</li>
          <li><strong>Sınırlayıcı İnançları Yeniden Yapılandırın:</strong> Olumsuz inançları pozitif ve güçlendirici ifadelerle değiştirin.</li>
          <li><strong>Bolluk Görselleştirmesi Yapın:</strong> Kendinizi zengin ve bolluk içinde hayal edin. Bu görselleştirmeyi her gün pratik edin.</li>
          <li><strong>Duygusal Ankrajlar Oluşturun:</strong> Bolluk hissini yaşadığınız anları hatırlayın ve bu duyguyu ankorlaştırın.</li>
        </ol>
        
        <h2>Zihinsel Monopoly Oyunu</h2>
        <p>Şimdi gelin bu egzersizi yapalım:</p>
        <p>Hayal gücünüzü kullanarak, hayalinizdeki yaşamı oluşturun. Bu hayatta ne kadar paranız var? Nasıl bir evde oturuyorsunuz? Ne tür bir araba kullanıyorsunuz? Nasıl tatiller yapıyorsunuz?</p>
        
        <blockquote>
          "Zenginlik bir zihin halidir. Para ise bu zihin halinin fiziksel tezahürüdür." - Banu Gökcül
        </blockquote>
        
        <h3>Bolluk Bilinci Geliştirme Egzersizi</h3>
        <p>Her sabah uyandığınızda, minnettar olduğunuz 10 şeyi listeleyin. Bu basit pratik, zihninizi bolluk frekansına ayarlar.</p>
        
        <h2>Kuantum Sıçrama ile Para Bloklarını Kaldırın</h2>
        <p>"Kuantum Sıçrama için Ayna Tekniği" kullanarak, para konusundaki derin bilinçaltı bloklarınızı hızlı bir şekilde temizleyebilirsiniz. Bu teknik ile:</p>
        
        <ul>
          <li>Para konusundaki korkularınızı aşabilirsiniz</li>
          <li>Zenginlik hakkındaki suçluluk duygularınızdan kurtulabilirsiniz</li>
          <li>Bolluk bilincine ulaşabilirsiniz</li>
          <li>Finansal başarı için gerekli zihinsel altyapıyı oluşturabilirsiniz</li>
        </ul>
        
        <h2>Sonuç</h2>
        <p>Zengin olmak, sadece para kazanmakla ilgili değildir. Asıl mesele, zihninizi bolluk için programlamak ve para ile sağlıklı bir ilişki kurmaktır. NLP teknikleri ve bilinçaltı programlama ile bu dönüşümü gerçekleştirebilirsiniz.</p>
        
        <p>Unutmayın: Dış dünyadaki zenginliğiniz, iç dünyanızdaki zenginlik bilincinizin yansımasıdır.</p>
      `
    },
    'avatar-sonbahar-ayilmalari': {
      title: 'Avatarın Sonbahar Ayılmaları',
      date: '12 Eylül 2018',
      author: 'Banu Gökcül',
      image: 'https://akarma.com.tr/upload/akarma/b2.jpg',
      category: 'Farkındalık',
      comments: 5,
      content: `
        <p class="lead">Algı Herşeydir (!) Kendin Olmak: "Hiç kimse bakmıyorken kimsin"</p>
        
        <h2>Otantik Olmak</h2>
        <p>Hayatımızın büyük bir bölümünde, başkalarının beklentilerine göre yaşarız. Ailemizin, toplumun, iş dünyasının bize biçtiği rolleri oynarız. Peki ya gerçek benliğimiz? Ya kimse bakmıyorken kim olduğumuz?</p>
        
        <h3>Kendinizi Keşfetme Egzersizi</h3>
        <p>Aşağıdaki soruları kendinize sorun ve dürüstçe yanıtlayın:</p>
        
        <ol>
          <li>Hiç kimse olmadığında nasıl davranıyorum?</li>
          <li>Gerçekten neyi seviyorum, neyi sevmiyorum?</li>
          <li>Hangi rolleri oynuyorum ve bunlardan hangisi gerçekten benim?</li>
          <li>Başkalarını memnun etmek için ne gibi fedakarlıklar yapıyorum?</li>
          <li>Kendi değerlerimle çelişen hangi davranışlarda bulunuyorum?</li>
        </ol>
        
        <h2>Etki Etme ve Etkilenme</h2>
        <p>İnsanlar olarak, sürekli bir etkileşim içindeyiz. Bazen etki ederiz, bazen etkileniriz. Ancak bu etkileşimde özgünlüğümüzü korumak kritik öneme sahiptir.</p>
        
        <blockquote>
          "En güçlü silahımız, otantik benliğimizdir. Maskelerimizi çıkardığımızda gerçek gücümüze ulaşırız." - Banu Gökcül
        </blockquote>
        
        <h3>Avatar ve Gerçek Benlik</h3>
        <p>Sosyal medya çağında, hepimiz bir "avatar" yaratıyoruz - dış dünyaya gösterdiğimiz bir imaj. Ancak bu avatar ile gerçek benliğimiz arasındaki mesafe ne kadar büyük?</p>
        
        <h2>Sonbahar Ayılmaları</h2>
        <p>Sonbahar, doğanın dönüşüm zamanıdır. Yapraklar düşer, ağaçlar soyunur, kendilerine dönerler. Bizim için de böyle "ayılma" dönemleri gereklidir.</p>
        
        <ul>
          <li><strong>Toplumsal Beklentilerden Ayılmak:</strong> "Olmalı, yapmalı" cümlelerinden kurtulmak</li>
          <li><strong>Sahte İlişkilerden Ayılmak:</strong> Sizi siz yapan ilişkilere odaklanmak</li>
          <li><strong>Ego Oyunlarından Ayılmak:</strong> Gösteriş yerine özgünlüğü seçmek</li>
          <li><strong>Geçmişten Ayılmak:</strong> Eski inançların bizi sınırlamasına izin vermemek</li>
        </ul>
        
        <h2>Özgün Bir Tavır Geliştirmek</h2>
        <p>Özgün olmak, farklı olmak demek değildir. Özgün olmak, kendine sadık kalmak demektir. İşte özgün bir tavır geliştirmenin yolları:</p>
        
        <h3>1. Değerlerinizi Netleştirin</h3>
        <p>Sizin için gerçekten önemli olan nedir? Bu değerlere göre yaşıyor musunuz?</p>
        
        <h3>2. Sınırlarınızı Belirleyin</h3>
        <p>Neye "evet", neye "hayır" diyeceğinizi bilin. Bu sınırlar sizi korur ve güçlendirir.</p>
        
        <h3>3. Kendi Sesinizi Bulun</h3>
        <p>İçinizdeki sesi dinleyin. Bu ses, ruhunuzun dilidir ve sizin gerçeğinizdir.</p>
        
        <h3>4. Korkularınızla Yüzleşin</h3>
        <p>Özgün olmaktan bizi alıkoyan şey genellikle korkudur - reddedilme, dışlanma, yargılanma korkusu.</p>
        
        <h2>NLP ve Otantik Benlik</h2>
        <p>NLP teknikleri ile özgün benliğinize ulaşabilirsiniz:</p>
        
        <ul>
          <li>Sahte inançları tespit edin ve dönüştürün</li>
          <li>Geçmiş yaşantılardan kaynaklanan sınırlamaları kaldırın</li>
          <li>Özgüven ve öz değer çalışmaları yapın</li>
          <li>Gerçek değerlerinizle uyumlu bir yaşam tasarlayın</li>
        </ul>
        
        <h2>Sonuç Egzersiz: "Hiç Kimse Bakmıyorken"</h2>
        <p>Bu hafta, hiç kimse olmadığında ne yaptığınızı gözlemleyin. Yalnızken nasıl davrandığınız, en otantik halinizdir. Bu gözlem, size kim olduğunuz hakkında çok şey söyleyecektir.</p>
        
        <p>Sonra, bu otantik benliği dış dünyaya taşımaya başlayın. Küçük adımlarla, maskelerinizi çıkarın ve gerçek kendiniz olun.</p>
      `
    },
    'bilissel-tedavi': {
      title: 'BİLİŞSEL TEDAVİ',
      date: '12 Ağustos 2018',
      author: 'Banu Gökcül',
      image: 'https://akarma.com.tr/upload/akarma/b3.jpg',
      category: 'Psikoloji',
      comments: 13,
      content: `
        <p class="lead">Bilişsel tedavi Aaron Beck tarafından ortaya konulmuştur. Bu tedavi, kişilerin duygu ve davranışlarının kendi oluşturdukları dünya ve yaşantı ile büyük ölçüde belirlenmesi üzerine kurulmuştur.</p>
        
        <h2>Bilişsel Tedavinin Temelleri</h2>
        <p>Bilişsel terapi, düşünce-duygu-davranış üçgeni üzerine inşa edilmiştir. Bu üçlü arasındaki ilişkiyi anlamak, duygusal sorunların kökenine inmek için kritik öneme sahiptir.</p>
        
        <h3>Düşünce → Duygu → Davranış Döngüsü</h3>
        <p>Örnek bir senaryo:</p>
        <ul>
          <li><strong>Düşünce:</strong> "Ben başarısızım, hiçbir şey yapamam."</li>
          <li><strong>Duygu:</strong> Üzüntü, çaresizlik, değersizlik</li>
          <li><strong>Davranış:</strong> Çekilme, pasiflik, yeni şeyler denemekten kaçınma</li>
        </ul>
        
        <h2>Otomatik Düşünceler</h2>
        <p>Bilişsel terapinin temel kavramlarından biri "otomatik düşünceler"dir. Bunlar, zihnimizde otomatik olarak beliren, genellikle farkına varmadığımız düşüncelerdir.</p>
        
        <h3>Otomatik Düşüncelerin Özellikleri:</h3>
        <ol>
          <li><strong>Hızlı ve Spontane:</strong> Ani ve kontrolsüz bir şekilde ortaya çıkarlar</li>
          <li><strong>İnanılır:</strong> Genellikle sorgulanmadan kabul edilirler</li>
          <li><strong>İstemsiz:</strong> Kasıtlı olarak düşünülmezler</li>
          <li><strong>Tekrarlayıcı:</strong> Benzer durumlarda sürekli tekrarlanırlar</li>
        </ol>
        
        <h2>Bilişsel Çarpıtmalar</h2>
        <p>Otomatik düşüncelerimiz genellikle mantık hatalarıyla doludur. Bunlara "bilişsel çarpıtmalar" denir:</p>
        
        <h3>1. Hep Ya Da Hiç Düşüncesi</h3>
        <p>"Ya tam başarılı olurum ya da tam başarısız." Ortası yok.</p>
        <p><em>Örnek:</em> "Bu sınavdan 100 alamadım, demek ki aptalım."</p>
        
        <h3>2. Aşırı Genelleme</h3>
        <p>Tek bir olumsuz olayı, her zaman olacak bir kural gibi görmek.</p>
        <p><em>Örnek:</em> "Bir kez reddedildim, demek ki kimse beni sevmez."</p>
        
        <h3>3. Zihinsel Filtreleme</h3>
        <p>Sadece olumsuz detaylara odaklanmak, olumluları görmezden gelmek.</p>
        <p><em>Örnek:</em> Sunumunuz 9 kişi tarafından beğenildi, 1 kişi eleştirdi. Sadece eleştiriyi düşünüyorsunuz.</p>
        
        <h3>4. Olumluyu Olumsuz Yapmak</h3>
        <p>Olumlu deneyimleri olumsuz şeylere dönüştürmek.</p>
        <p><em>Örnek:</em> "Beni övdüler ama sadece nazik olmak için söylediler."</p>
        
        <h3>5. Acele Sonuç Çıkarma</h3>
        <p>Yeterli kanıt olmadan olumsuz sonuçlara varmak.</p>
        <ul>
          <li><strong>Zihin Okuma:</strong> "Beni beğenmediğini biliyorum."</li>
          <li><strong>Falcılık:</strong> "Her şey kötü gidecek, eminim."</li>
        </ul>
        
        <h3>6. Büyütme/Küçültme</h3>
        <p>Hataları büyütmek, başarıları küçültmek.</p>
        
        <h3>7. Duygusal Akıl Yürütme</h3>
        <p>"Böyle hissediyorum, o halde doğru olmalı."</p>
        <p><em>Örnek:</em> "Kendimi değersiz hissediyorum, demek ki değersizim."</p>
        
        <h3>8. "Yapmalı" İfadeleri</h3>
        <p>"Yapmalıyım, olmalıyım, gerekir" gibi katı kurallar.</p>
        
        <h3>9. Etiketleme</h3>
        <p>Kendine ya da başkalarına küçük düşürücü etiketler takmak.</p>
        <p><em>Örnek:</em> "Ben aptalmm, o pislik."</p>
        
        <h3>10. Kişiselleştirme</h3>
        <p>Her şeyin sorumluluğunu üstlenmek.</p>
        <p><em>Örnek:</em> "Projeyi başkası beceremsizce yaptı, keşke ben yapsaydım."</p>
        
        <h2>Bilişsel Tedavi Süreci</h2>
        
        <h3>1. Farkındalık Aşaması</h3>
        <p>İlk adım, otomatik düşüncelerinizi fark etmektir. Bunun için düşünce günlüğü tutabilirsiniz:</p>
        <ul>
          <li>Durum: Ne oldu?</li>
          <li>Düşünce: Aklınızdan ne geçti?</li>
          <li>Duygu: Nasıl hissettiniz?</li>
          <li>Davranış: Ne yaptınız?</li>
        </ul>
        
        <h3>2. Sorgulama Aşaması</h3>
        <p>Otomatik düşüncelerinizi sorgulayın:</p>
        <ul>
          <li>Bu düşünceyi destekleyen kanıtlar neler?</li>
          <li>Bu düşünceyle çelişen kanıtlar neler?</li>
          <li>Alternatif açıklamalar olabilir mi?</li>
          <li>En kötü, en iyi ve en gerçekçi senaryo nedir?</li>
          <li>Bu düşünce bir arkadaşınızın olsaydı, ona ne söylerdiniz?</li>
        </ul>
        
        <h3>3. Yeniden Yapılandırma Aşaması</h3>
        <p>Olumsuz ve mantıksız düşünceleri daha gerçekçi ve dengeli düşüncelerle değiştirin.</p>
        
        <p><strong>Önce:</strong> "Hata yaptım, ben aptalım."</p>
        <p><strong>Sonra:</strong> "Hata yaptım, bu insani. Bundan ders çıkarabilirim."</p>
        
        <h2>Davranış Deneyleri</h2>
        <p>Bilişsel terapi, sadece düşünmekle kalmaz, davranışsal deneyler yapmanızı da önerir. İnançlarınızı test edin:</p>
        
        <p><em>Örnek:</em> "İnsanlar beni beğenmez" düşünceniz varsa, sosyal ortamlara gidin ve ne olduğunu gözlemleyin. Gerçekten herkes mi sizi beğenmiyor?</p>
        
        <h2>NLP ve Bilişsel Terapi Entegrasyonu</h2>
        <p>NLP teknikleri, bilişsel terapiyi güçlendirebilir:</p>
        <ul>
          <li><strong>Swish Pattern:</strong> Olumsuz düşünce kalıplarını olumlu olanlarla değiştirme</li>
          <li><strong>Reframing:</strong> Olayları farklı perspektiflerden görme</li>
          <li><strong>Anchoring:</strong> Olumlu duygu durumlarını ankorlaştırma</li>
          <li><strong>Timeline Therapy:</strong> Geçmiş olumsuz deneyimlerin etkisini azaltma</li>
        </ul>
        
        <h2>Günlük Pratikler</h2>
        
        <h3>1. Sabah Olumlamalar</h3>
        <p>Her sabah, kendinize olumlu ifadeler söyleyin. Bu, zihinizi gün boyunca pozitif yönde programlar.</p>
        
        <h3>2. Düşünce Durdurma Tekniği</h3>
        <p>Olumsuz bir düşünce geldiğinde, içinizden "DUR!" deyin ve dikkatlice başka bir konuya yönelin.</p>
        
        <h3>3. Minnet Günlüğü</h3>
        <p>Her gün 3-5 şey için minnettarlık duyduğunuzu yazın. Bu, zihninizi olumlu şeylere odaklamayı öğretir.</p>
        
        <h3>4. "Kanıtlar Mahkemesi"</h3>
        <p>Bir düşünceyi mahkemeye çıkardığınızı hayal edin. Düşünceniz suçlu mu yoksa masum mu?</p>
        
        <h2>Sonuç</h2>
        <p>Bilişsel terapi, düşüncelerimizin duygularımız ve davranışlarımız üzerindeki gücünü bize gösterir. Düşüncelerimizi değiştirerek, duygularımızı ve hayatımızı değiştirebiliriz.</p>
        
        <blockquote>
          "İnsanları rahatsız eden şeyler olayların kendisi değil, onlar hakkındaki görüşleridir." - Epiktetos
        </blockquote>
        
        <p>Unutmayın: Düşünceleriniz sadece düşüncelerdir, gerçeklik değil. Onları sorgulayabilir, değiştirebilir ve daha sağlıklı bir zihinsel yaşam oluşturabilirsiniz.</p>
      `
    }
  };

  const article = articles[slug];

  useEffect(() => {
    if (article) {
      document.title = `${article.title} | akarma`;
    }
  }, [article, slug]);

  if (!article) {
    return (
      <div className="pt-24 pb-20 min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-4xl font-bold mb-4">Makale Bulunamadı</h1>
          <p className="text-gray-600 mb-8">Aradığınız makale bulunamadı.</p>
          <Link
            to="/makaleler"
            className="inline-flex items-center px-6 py-3 bg-gradient-to-r from-akarma-blue to-akarma-blue-700 text-white rounded-full font-semibold"
          >
            <ArrowLeft size={20} className="mr-2" />
            Makalelere Dön
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="article-detail pt-24 pb-20">
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-akarma-blue to-akarma-blue-700 text-white py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <Link
              to="/makaleler"
              className="inline-flex items-center text-white/80 hover:text-white mb-6 transition-colors"
            >
              <ArrowLeft size={20} className="mr-2" />
              Makalelere Dön
            </Link>
            <div className="inline-block px-4 py-1 bg-white/20 rounded-full text-sm font-medium mb-4">
              {article.category}
            </div>
            <h1 className="text-4xl md:text-5xl font-bold mb-6">{article.title}</h1>
            <div className="flex flex-wrap items-center gap-6 text-white/90">
              <div className="flex items-center">
                <User size={18} className="mr-2" />
                {article.author}
              </div>
              <div className="flex items-center">
                <Calendar size={18} className="mr-2" />
                {article.date}
              </div>
              <div className="flex items-center">
                <MessageCircle size={18} className="mr-2" />
                {article.comments} yorum
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Featured Image */}
      <section className="py-12 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="max-w-5xl mx-auto">
            <img
              src={article.image}
              alt={article.title}
              className="w-full h-[400px] md:h-[500px] object-cover rounded-2xl shadow-2xl"
            />
          </div>
        </div>
      </section>

      {/* Article Content */}
      <section className="py-12">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <article 
              className="prose prose-lg max-w-none
                prose-headings:font-bold prose-headings:text-gray-900
                prose-h2:text-3xl prose-h2:mt-12 prose-h2:mb-6
                prose-h3:text-2xl prose-h3:mt-8 prose-h3:mb-4
                prose-p:text-gray-700 prose-p:leading-relaxed prose-p:mb-6
                prose-ul:my-6 prose-ol:my-6
                prose-li:text-gray-700 prose-li:my-2
                prose-strong:text-gray-900 prose-strong:font-semibold
                prose-blockquote:border-l-4 prose-blockquote:border-akarma-blue 
                prose-blockquote:pl-6 prose-blockquote:py-2 
                prose-blockquote:bg-blue-50 prose-blockquote:rounded-r-lg
                prose-blockquote:text-gray-800 prose-blockquote:italic
                prose-a:text-akarma-blue prose-a:no-underline hover:prose-a:underline
                prose-img:rounded-xl prose-img:shadow-lg"
              dangerouslySetInnerHTML={{ __html: article.content }}
            />
          </div>
        </div>
      </section>

      {/* Author Bio */}
      <section className="py-12 bg-gradient-to-br from-blue-50 to-purple-50">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <div className="bg-white p-8 rounded-2xl shadow-lg">
              <div className="flex items-start space-x-6">
                <div className="flex-shrink-0">
                  <div className="w-24 h-24 bg-gradient-to-br from-akarma-blue to-akarma-blue-700 rounded-full flex items-center justify-center">
                    <User size={48} className="text-white" />
                  </div>
                </div>
                <div>
                  <h3 className="text-2xl font-bold mb-2">{article.author}</h3>
                  <p className="text-gray-600 mb-4">Davranış Bilimleri Uzmanı, PhD</p>
                  <p className="text-gray-700 leading-relaxed">
                    20+ yıllık deneyimi ile NLP, koçluk, kurumsal eğitim ve kişisel gelişim alanlarında 
                    uzman. Kuantum Sıçrama için Ayna Tekniği'nin yaratıcısı. 4 kitabın yazarı ve 
                    100'den fazla makalenin sahibi.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Related Articles */}
      <section className="py-12">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-3xl font-bold mb-8 text-center">Diğer Makaleler</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {Object.entries(articles)
                .filter(([key]) => key !== slug)
                .map(([key, item]) => (
                  <Link
                    key={key}
                    to={`/makaleler/${key}`}
                    className="bg-white rounded-xl shadow-lg overflow-hidden card-hover"
                  >
                    <img
                      src={item.image}
                      alt={item.title}
                      className="w-full h-48 object-cover"
                    />
                    <div className="p-6">
                      <div className="text-sm text-akarma-blue font-medium mb-2">{item.category}</div>
                      <h3 className="text-xl font-bold mb-2">{item.title}</h3>
                      <div className="flex items-center text-sm text-gray-500">
                        <Calendar size={14} className="mr-1" />
                        {item.date}
                      </div>
                    </div>
                  </Link>
                ))}
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-12 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="text-3xl font-bold mb-4">Kişisel Gelişim Yolculuğunuza Başlayın</h2>
            <p className="text-xl text-gray-600 mb-8">
              Profesyonel koçluk ve danışmanlık hizmetlerimiz hakkında bilgi almak için 
              bizimle iletişime geçin.
            </p>
            <Link
              to="/iletisim"
              className="inline-flex items-center px-8 py-4 bg-gradient-to-r from-akarma-blue to-akarma-blue-700 text-white rounded-full font-semibold hover:shadow-lg transition-all duration-300"
            >
              İletişime Geçin
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ArticleDetail;
